import React from 'react';
import {useSelector} from "react-redux";
import DashboardSummeryInfoSection from "./dashboardSummeryInfoSection";

const DashboardInfo = () => {
    const partnerInfo = useSelector(state => state.partnerDetails);
    if (partnerInfo === null) return <></>;
    let showingName = "";
    if (partnerInfo.contactPerson) showingName = partnerInfo.contactPerson.split(" ")[0];
    return (
        <div className="d-flex flex-column mt-4">
            {/*<div className="mb-3 text-start">*/}
            {/*    <span className="partner-welcome">Welcome, {showingName}</span>*/}
            {/*</div>*/}
            <DashboardSummeryInfoSection partnerInfo={partnerInfo}/>
        </div>
    )
}

export default DashboardInfo;